<template>
    <div id="main-wrapper" style="overflow: visible !important;">
        <vue-snotify></vue-snotify>
        <Header :username="username"></Header>
        <Sidebar :username="username"></Sidebar>
        <div class="page-wrapper">
            <router-view/>
        </div>
    </div>
</template>

<script>
    import Header from '../components/Header';
    import Sidebar from '../components/Sidebar';
    import UserService from '../services/UserService';
    import AuthService from '../services/AuthService';

    export default {
        name: 'Base',
        components: {Sidebar, Header},
        data() {
            return {
                username: ''
            }
        },
        created() {
            this.init();
            this.getUsername();
        },
        methods: {
            async init() {
                this.$store.dispatch('setUser', AuthService.tokenDecode(AuthService.getToken()));
                this.$store.dispatch('setIsAdmin', AuthService.isAdmin());
                this.$store.dispatch('setIsUser', AuthService.isUser());
            },
            async getUsername() {
                await UserService.getUser(this.$store.getters.getUser.id)
                    .then(response => {
                        if (response.status === 200 && response.data.username) {
                            this.username = response.data.username;
                            localStorage.setItem('username', this.username);
                        }
                    })
                    .catch(error => {
                        if (error.response.status === 403) {
                            this.$router.go(this.$router.currentRoute);
                        }
                    });
            }
        }
    }
</script>
